import { initFederation } from '@angular-architects/native-federation';
import { BUILD_URLs } from './environments/environment';

initFederation(BUILD_URLs.MANIFEST)
  .catch((err) => console.error(err))
  .then((_) => import('./bootstrap'))
  .catch((err) => console.error(err));
